import apiClient from "./api/apiClient";
import {
  OrganizationData,
  OrganizationDataAvailability,
  PlanData,
  PodData,
} from "../interfaces/Pod.interface";

import { PaymentVerificationRequest, PaymentVerificationResponse } from "../types/bookings";

export const fetchPodDataByOrganization = async (
  bookingID: any
): Promise<PodData[]> => {
  try {
    const response = await apiClient.get<{ data: PodData[] }>(
      `/pod/organization/${bookingID}`
    );
    return response.data.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return [];
  }
};

export const fetchOrganizationBySlug = async (
  organizationName: string
): Promise<OrganizationData> => {
  try {
    const response = await apiClient.get<{ data: OrganizationData }>(
      `/organization/slug/${organizationName}`
    );
    return response.data.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw new Error("Error fetching data");
  }
};

// fetchOrganizationBySlugAvailability has been removed and merged with fetchOrganizationBySlug

export const fetchPlanDataByPod = async (
  selectedPodId: string | null | undefined
): Promise<PlanData[]> => {
  try {
    const response = await apiClient.get<{ data: PlanData[] }>(
      `/plan/pod/${selectedPodId}`
    );
    return response.data.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return [];
  }
};

export const bookPodWithPlan = async (dataToSend: any): Promise<any> => {
  try {
    // No need to manually set auth headers as apiClient handles it
    const response = await apiClient.post<any>(`/book`, dataToSend);
    return response.data;
  } catch (error) {
    console.error("Error posting data:", error);
    throw error;
  }
};

//rename this API
export const fetchPodPlanById = async (podId: string): Promise<any> => {
  try {
    const response = await apiClient.get<any>(`/book/${podId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching pod plan data:", error);
    throw error;
  }
};

export const fetchRemoteControlPodPlanById = async (
  podId: string
): Promise<any> => {
  try {
    const response = await apiClient.get<any>(`/book/${podId}/remote`);
    return response.data;
  } catch (error) {
    console.error("Error fetching remote control pod plan data:", error);
    throw error;
  }
};

export const putRemoteControlPodPlanById = async (
  pod_id: string | null | undefined,
  booking_id: string | null,
  action: {
    light?: number;
    door?: number;
  }
): Promise<any> => {
  try {
    const response = await apiClient.put<any>(
      `/book/${booking_id}/remote`,
      {
        pod_id,
        action,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching remote control pod plan data:", error);
    throw error;
  }
};

export const postCheckoutPodPlanById =
  async (postDataToSend: {}): Promise<any> => {
    try {
      const response = await apiClient.post<any>(
        `/book/${postDataToSend}/checkout`
      );
      return response.data;
    } catch (error) {
      console.error(
        "Error occurred during the checkout process. Unable to post checkout data for the pod plan. Please check the booking ID and network connectivity:",
        error
      );
      throw error;
    }
  };


  export const verifyPayment = async (verificationData: PaymentVerificationRequest): Promise<PaymentVerificationResponse> => {
    try {
      // No need to manually set auth headers as apiClient handles it
      const response = await apiClient.post(
        `/book/payment/verify`,
        verificationData
      );
      return response.data;
    } catch (error: any) {
      if (error.response?.data) {
        return error.response.data;
      }
      throw error;
    }
  };
